import React from 'react';
import './Panorama.scss';

interface PanoramaProps {
  targetId: string;
}

export const Panorama = ({ targetId }: PanoramaProps) => {
  return <div id={targetId} className="panorama" />;
};
